import { CircleAlert, Loader2 } from "lucide-react";

import { HoverHintTrigger } from "@/components/ui/title-help";
import { cn } from "@/lib/utils";

export function deferredCommitStatusGlyphVisible({
  pending,
  isDirty,
  commitError,
}: {
  pending?: boolean;
  isDirty: boolean;
  commitError?: string | null;
}): boolean {
  const errorMessage = commitError?.trim() ?? "";
  if (errorMessage !== "" && !isDirty) {
    return true;
  }
  return pending === true;
}

/** Spinner while a field save is in flight, or an alert that holds the error. */
export function DeferredCommitStatusGlyph({
  pending,
  isDirty,
  commitError,
  className,
}: {
  pending?: boolean;
  isDirty: boolean;
  commitError?: string | null;
  className?: string;
}): JSX.Element | null {
  const errorMessage = commitError?.trim() ?? "";
  if (errorMessage !== "" && !isDirty) {
    return (
      <HoverHintTrigger
        className={cn("shrink-0", className)}
        trigger={
          <button
            type="button"
            tabIndex={-1}
            className="inline-flex shrink-0 rounded p-0.5 text-rose-700 focus:outline-none focus:ring-2 focus:ring-rose-500 focus:ring-offset-1"
            aria-label={errorMessage}
          >
            <CircleAlert className="h-4 w-4 shrink-0" aria-hidden />
          </button>
        }
      >
        <span className="block break-words">{errorMessage}</span>
      </HoverHintTrigger>
    );
  }
  if (pending === true) {
    return (
      <span className={cn("inline-flex shrink-0 text-slate-500", className)} aria-label="Saving">
        <Loader2 className="h-4 w-4 shrink-0 animate-spin" aria-hidden />
      </span>
    );
  }
  return null;
}
